import { render, staticRenderFns } from "./ClawPointDetail.vue?vue&type=template&id=f23b41b8&scoped=true&"
import script from "./ClawPointDetail.vue?vue&type=script&lang=js&"
export * from "./ClawPointDetail.vue?vue&type=script&lang=js&"
import style0 from "./ClawPointDetail.vue?vue&type=style&index=0&id=f23b41b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23b41b8",
  null
  
)

export default component.exports